import Constant from '@/common/constant/Constant';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import Utils from '@/common/utils/utils';
import _, { cloneDeep, isEqual } from 'lodash';
import {
    updateProductManagement,
    getListProductManagement
} from '@/service/productManagementService';
import { I18n } from 'aws-amplify';
import { Storage } from 'aws-amplify';

export const addNewLineProduct = (listDataProduct, setListDataProduct, setIsEdit) => {
    let order = listDataProduct.length;

    const newLineData = {
        id: Date.now().toString(),
        name: '',
        error: '',
        order: order,
        createNewLine: true
    };
    setIsEdit(true);
    setListDataProduct(prev => [newLineData, ...prev]);
};

export const removeNewLine = (index, setListDataProduct) => {
    setListDataProduct(prevState => {
        const newInputs = [...prevState];
        if (index !== -1) {
            newInputs.splice(index, 1);
            let nameDuplicate = findNameDuplicate(newInputs);

            newInputs.forEach((item, i) => {
                if (
                    !nameDuplicate.includes(item.name) &&
                    item?.error === 'MSG-CM-DATA-DUPLICATION'
                ) {
                    newInputs[i] = { ...newInputs[i], error: '' };
                }
            });
            return newInputs;
        }
        
        return newInputs;
    });
};

export const updatePanelEditionList = (panelList, setPanelList, item, panelType) => {
    const panelProductList = panelList.filter(panel =>
        [Constant.PANEL_TYPE.PRODUCT_MANAGEMENT].includes(panel.type)
    );
    let newPanelList = _.cloneDeep(panelList);
    panelProductList?.forEach(product => {
        let tabProductList = product.tabList?.map(tab =>
            tab.id === Constant.PANEL_TYPE.PRODUCT_MANAGEMENT
                ? {
                      ...tab,
                      productInfo: item,
                      componentType: panelType
                  }
                : tab
        );
        const newPanelProductManagement = {
            ...product,
            tabList: tabProductList
        };
        newPanelList = newPanelList.map(panel =>
            panel.type === product.type ? (panel = newPanelProductManagement) : panel
        );
    });

    setPanelList(newPanelList);
};

export const isDisabledButtonCancel = (
    isEdit, 
    listDataProduct, 
    listDataDefault,
    listDeleteProduct,
    listEditStatusProduct,
    isEditIncreaseRate,
    increaseRateInputError
) => {
    let newLineProducts = listDataProduct.filter(product => product?.createNewLine === true);
    if (isEditIncreaseRate) return false;
    if (
        isEqual(listDataProduct, listDataDefault) &&
        Utils.isEmptyArray(listDeleteProduct) &&
        Utils.isEmptyArray(listEditStatusProduct)
    )
        return true;
    // if (Utils.isEmptyArray(newLineProducts)) {
    //     return !isEdit;
    // }
    return false;
};

export const isDisabledButtonSubmit = (
    hasError,
    listDataProduct,
    isEdit,
    listDataDefault,
    listDeleteProduct,
    listEditStatusProduct,
    isEditIncreaseRate,
    increaseRateInputError
) => {
    if (isEditIncreaseRate && Utils.isEmptyString(increaseRateInputError)) return false;
    if (
        isEqual(listDataProduct, listDataDefault) &&
        Utils.isEmptyArray(listDeleteProduct) &&
        Utils.isEmptyArray(listEditStatusProduct)
    )
        return true;
    let newLineProducts = listDataProduct.filter(product => product?.createNewLine === true);
    if (Utils.isEmptyArray(newLineProducts) && !isEdit) return true;

    let isRequired = newLineProducts.some(
        product => Utils.isEmptyString(product.name) || !product.name.trim() || product.error
    );
    if (isRequired) return true;

    if (hasError) return true;
    return false;
};

export const findNameDuplicate = arr => {
    let valueArr = arr.map(item => item.name).filter(item => !!item);
    const nameDuplicate = valueArr.filter((item, idx) => valueArr.indexOf(item) !== idx);
    return nameDuplicate;
};

export const sortListProductByOrderDesc = array => {
    if (Utils.isEmptyArray(array)) return [];
  
    return array.sort((a, b) => {
      const orderComparison = parseInt(b.order) - parseInt(a.order);
  
      if (orderComparison !== 0) {
        return orderComparison;
      } else {
        // Nếu trường order giống nhau, sắp xếp theo updatedAt
        return new Date(b.updatedAt) - new Date(a.updatedAt);
      }
    });
  };

export const onSubmitData = async (
    API,
    listDataProduct,
    setListDataProduct,
    setIsLoading,
    setTriggerReload,
    userId,
    setIsEdit,
    enqueueSnackbar,
    setHasError,
    listDeleteProduct,
    listEditStatusProduct,
    setIsShowPopUpReload,
    setListDeleteProduct,
    setListEditStatusProduct,
    increaseRateInput,
) => {
    setIsLoading(true);
    let listDataProductFilter = listDataProduct.filter(product => product.isPositionChanged || product.createNewLine);
    let requestBody = {
        userId: userId,
        listProduct: JSON.stringify(listDataProductFilter),
        listDeleteProduct:  JSON.stringify(listDeleteProduct),
        listEditStatusProduct:  JSON.stringify(listEditStatusProduct),
        type: ProductManagementConstant.METHOD_PRODUCT.CREATE_AND_UPDATE_PRODUCT_LIST,
        increaseRate: increaseRateInput
    };

    let res = await updateProductManagement(API, requestBody);
    if(!res?.status) {
        if(res.errorMessage === 'COMMSG030'){
            setIsLoading(false);
            setIsShowPopUpReload(true);
            return
        }
        let listProductErrors = Utils.convertJSONDataToObject(res?.listProductErrors);
        listProductErrors =listProductErrors?.map(item => item.id);

        listDataProduct = listDataProduct?.map(item => {
            if(listProductErrors.includes(item.id)) {
                item.error = 'MSG-CM-DATA-DUPLICATION'
            }
            return item;
        })
        setHasError(true);
        setListDataProduct(listDataProduct);
        setIsLoading(false);
        return;
    }
    setListDeleteProduct([])
    setListEditStatusProduct([])
    setTriggerReload(Date.now().toString());

    //reset state
    setIsEdit(false);
    setHasError(false);

    enqueueSnackbar(I18n.get('MSG-CM-UPDATE-DATA-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
};



export const getListProductData = async (
    API,
    setListDataProduct,
    setIsLoading,
    setListDataDefault,
    setIncreaseRateInput,
    setIncreaseRate
) => {
    setIsLoading(true);
    let requestBody = {
        type: ProductManagementConstant.METHOD_PRODUCT.GET_LIST_PRODUCT
    };
    let res = await getListProductManagement(API, requestBody);
    if (!res.status) {
        setIsLoading(false);
        return;
    }
    let listProduct = Utils.convertJSONDataToObject(res.listProduct ? res.listProduct : []);
    listProduct = listProduct.map(product => ({
        ...product,
        name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, product.name)
    }));
    listProduct = sortListProductByOrderDesc(listProduct);
    listProduct = listProduct.filter(product =>  Utils.isEmpty(product.deletedAt))
    setListDataDefault(cloneDeep(listProduct));
    setListDataProduct([...listProduct]);
    setIsLoading(false);
    setIncreaseRate(res?.increaseRate);
    setIncreaseRateInput(res?.increaseRate);
};

export const onCancelResetData = (
    setIsShowPopUpCancel,
    setIsEdit,
    setHasError,
    setListDataProduct,
    listDataDefault,
    setListDeleteProduct,
    setListEditStatusProduct,
    increaseRate,
    setIncreaseRateInput,
    setIncreaseRateInputError
) => {
    setIsEdit(false);
    setHasError(false);
    setListDataProduct(cloneDeep(listDataDefault));
    setListDeleteProduct([]);
    setListEditStatusProduct([])
    setIncreaseRateInput(increaseRate);
    setIncreaseRateInputError('');
    setIsShowPopUpCancel(false);
};

export const onClickYesCancel = async (
    API,
    listDataProduct,
    setListDataProduct,
    setIsLoading,
    setTriggerReload,
    userId,
    setIsEdit,
    enqueueSnackbar,
    setHasError,
    setIsShowPopUpCancel,
    hasError,
    isEdit,
    setIsClosePanelProduct,
    listDeleteProduct,
    listEditStatusProduct,
    setIsShowPopUpReload,
    setListDeleteProduct,
    setListEditStatusProduct,
    increaseRateInput,
    isEditIncreaseRate,
    increaseRateInputError
) => {
    if(hasError || !Utils.isEmptyString(increaseRateInputError)) {
        setIsClosePanelProduct({isClose: false});
        setIsShowPopUpCancel(false);
        return false;
    }

    let newLineProducts = listDataProduct.filter(product => product?.createNewLine === true);

    if (Utils.isEmptyArray(newLineProducts) && (isEdit || isEditIncreaseRate)) {
        setIsShowPopUpCancel(false);
        await onSubmitData(
            API,
            listDataProduct,
            setListDataProduct,
            setIsLoading,
            setTriggerReload,
            userId,
            setIsEdit,
            enqueueSnackbar,
            setHasError,
            listDeleteProduct,
            listEditStatusProduct,
            setIsShowPopUpReload,
            setListDeleteProduct,
            setListEditStatusProduct,
            increaseRateInput
        );
        setIsClosePanelProduct({isClose: false});
        return true;
    };
    
    let isRequired = newLineProducts.some(product => Utils.isEmptyString(product.name) || !product.name.trim());
    if(isRequired) {
        let listDataProductClone = cloneDeep(listDataProduct);
        listDataProductClone.forEach(product => {
            if(product?.createNewLine && (Utils.isEmptyString(product.name) || !product.name.trim())) {
                product.error = 'COMM01MSG11'
            }
        })
        setListDataProduct(listDataProductClone);

        setIsClosePanelProduct({isClose: false});
        setIsShowPopUpCancel(false);
        return false;
    };

    setIsClosePanelProduct({isClose: false});
    setIsShowPopUpCancel(false)
    await onSubmitData(
        API,
        listDataProduct,
        setListDataProduct,
        setIsLoading,
        setTriggerReload,
        userId,
        setIsEdit,
        enqueueSnackbar,
        setHasError,
        listDeleteProduct,
        listEditStatusProduct,
        setIsShowPopUpReload,
        setListDeleteProduct,
        setListEditStatusProduct
    );
    return true;
    
};